module.exports = __webpack_public_path__ + "img/icon-dislike.7151b0c3.svg";